<template>
    <div>

        <div class="ph-item" v-if="searchIsLoading">
            <div class="ph-col-12">
                <div class="ph-picture"></div>
                <div class="ph-row">
                    <div class="ph-col-12 empty"></div>
                    <div class="ph-col-4 big"></div>
                    <div class="ph-col-2 big empty"></div>
                    <div class="ph-col-2 big"></div>
                    <div class="ph-col-2 big empty"></div>
                    <div class="ph-col-2 big"></div>
                    <div class="ph-col-12"></div>
                    <div class="ph-col-12"></div>
                    <div class="ph-col-12"></div>
                </div>
            </div>
        </div>

        <form id="search_filters" v-if="filterOptions && filterOptions.length > 0">
            <div class="bggrey filters">
                <div class="uk-grid-small uk-margin-remove-left uk-padding uk-padding-remove-bottom uk-margin-small-bottom" uk-grid>
                    <div class="uk-width-1-1 uk-width-1-2@s uk-width-1-4@m uk-flex uk-flex-middle">
                        <input class="uk-checkbox uk-margin-small-right" style="border: 2px solid #ccc; height: 20px; width: 20px;background-color:white;"
                               type="checkbox"
                               v-model="selectedFilterValues[availabliltyFilterOption.option.code].boolValue"
                               :name="availabliltyFilterOption.option.code"
                               :id="availabliltyFilterOption.option.code"
                               @change="onFilterChanged">
                        <label :for="availabliltyFilterOption.option.code"
                               class="uk-text-bold">{{ resources['ItemsInStock'] }}</label>
                    </div>

                    <div v-if="familyFilterOption" class="uk-width-1-1 uk-width-1-2@s uk-width-1-4@m">
                        <button class="uk-button uk-width-expand uk-text-left uk-flex uk-flex-middle" style="background:white;"
                                :class="hasOptionSelectedValue(familyFilterOption.option.code) ? 'bgblue white' : ''"
                                type="button">
                            {{ familyFilterOption.option.name }}
                            <span uk-icon="icon: chevron-down" class="uk-margin-auto-left"></span>
                        </button>

                        <div uk-dropdown="mode: click; boundary: ! .uk-button-group .uk-button; boundary-align: true;">
                            <ul class="uk-nav uk-dropdown-nav">
                                <li v-for="filterValue in familyFilterOption.option.values">
                                    <input class="uk-checkbox uk-margin-small-right"
                                           type="checkbox"
                                           v-model="selectedFilterValues[familyFilterOption.option.code].codes"
                                           :value="filterValue.code"
                                           :name="familyFilterOption.option.code"
                                           :id="familyFilterOption.option.code + '_' + familyFilterOption.code"
                                           @change="onFilterChanged">
                                    <label :for="familyFilterOption.option.code + '_' + filterValue.code">{{ filterValue.name }}</label>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div v-else class="uk-width-1-1 uk-width-1-2@s uk-width-1-4@m"></div>

                    <div class="uk-width-1-1 uk-width-1-2@s uk-width-1-4@m"></div>
                    <div class="uk-width-1-1 uk-width-1-2@s uk-width-1-4@m"></div>

                    <div class="uk-width-1-1 uk-width-1-2@s uk-width-1-4@m">
                        <div class="uk-button bgwhite uk-search uk-search-defaul uk-width-1-1 designationsearch">
                            <span href="" class="blue uk-search-icon-flip" uk-search-icon></span>
                            <input class="uk-search-input" type="search" :placeholder="resources['SearchByDesignation']"
                                   :name="designationFilterOption.option.code"
                                   v-model="selectedFilterValues[designationFilterOption.option.code].text"
                                   @input="onInputFilter">
                        </div>
                    </div>

                    <div v-for="(filter, index) in mainFilterOptions"
                         class="uk-width-1-1 uk-width-1-2@s uk-width-1-4@m">

                        <button class="uk-button uk-width-expand uk-text-left uk-flex uk-flex-middle" style="background:white;"
                                :class="hasOptionSelectedValue(filter.option.code) ? 'bgblue white' : ''"
                                type="button">
                            {{ filter.option.name }}
                            <span uk-icon="icon: chevron-down" class="uk-margin-auto-left"></span>
                        </button>

                        <!-- enumeration -->
                        <div v-if="filter.option.type == 'Enumeration'"
                             uk-dropdown="mode: click; boundary: ! .uk-button-group .uk-button; boundary-align: true;">
                            <ul class="uk-nav uk-dropdown-nav">
                                <li v-for="filterValue in filter.option.values">
                                    <input class="uk-checkbox uk-margin-small-right"
                                           type="checkbox"
                                           v-model="selectedFilterValues[filter.option.code].codes"
                                           :value="filterValue.code"
                                           :name="filter.option.code"
                                           :id="filter.option.code + '_' + filterValue.code"
                                           @change="onFilterChanged">
                                    <label :for="filter.option.code + '_' + filterValue.code">{{ filterValue.name }}</label>
                                </li>
                            </ul>
                        </div>

                        <!-- number -->
                        <div v-if="filter.option.type == 'NumberInt' || filter.option.type == 'NumberDecimal'"
                             uk-dropdown="mode: click; boundary: ! .uk-button-group .uk-button; boundary-align: true;">
                            <div class="uk-inline" style="width:100px;">
                                <input class="uk-input" type="number"
                                       :name="filter.option.code + '_min'"
                                       v-model="selectedFilterValues[filter.option.code].minValue"
                                       :placeholder="filter.option.facets[0].aggregationValues.Min"
                                       @input="onInputFilter">
                            </div>
                            -
                            <div class="uk-inline" style="width:100px;">
                                <input class="uk-input" type="number"
                                       :name="filter.option.code + '_max'"
                                       v-model="selectedFilterValues[filter.option.code].maxValue"
                                       :placeholder="filter.option.facets[0].aggregationValues.Max"
                                       @input="onInputFilter">
                            </div>
                        </div>

                        <div v-if="filter.option.type == 'Text' || filter.option.type == 'TextArea' || filter.option.type == 'TextHtml' || filter.option.type == 'TextMarkdown'"
                             uk-dropdown="mode: click; boundary: ! .uk-button-group .uk-button; boundary-align: true;">
                            <div class="uk-inline" style="width:200px;">
                                <input class="uk-input" type="text" placeholder="..."
                                       :name="filter.option.code"
                                       v-model="selectedFilterValues[filter.option.code].text"
                                       @input="onInputFilter">
                            </div>
                        </div>
                    </div>
                </div>

                <ul class="uk-width-expand" uk-accordion v-if="advancedFilterOptions.length > 0">
                    <li class="">
                        <a class="uk-accordion-title uk-text-small uk-text-right uk-margin-medium-right uk-text-uppercase" href="#">{{ resources['AdvancedSearch'] }}</a>
                        <div class="uk-accordion-content uk-grid-small uk-margin-remove-left uk-padding uk-padding-remove-bottom
                            uk-padding-remove-top uk-margin-small-bottom uk-margin-small-top" uk-grid>

                            <div v-for="(filter, index) in advancedFilterOptions"
                                 class="uk-width-1-1 uk-width-1-2@s uk-width-1-4@m">

                                <button class="uk-button uk-width-expand uk-text-left uk-flex uk-flex-middle" style="background:white;"
                                        :class="hasOptionSelectedValue(filter.option.code) ? 'bgblue white' : ''"
                                        type="button">
                                    {{ filter.option.name }}
                                    <span uk-icon="icon: chevron-down" class="uk-margin-auto-left"></span>
                                </button>

                                <!-- enumeration -->
                                <div v-if="filter.option.type == 'Enumeration'"
                                     uk-dropdown="mode: click; boundary: ! .uk-button-group .uk-button; boundary-align: true;">
                                    <ul class="uk-nav uk-dropdown-nav">
                                        <li v-for="filterValue in filter.option.values">
                                            <input class="uk-checkbox uk-margin-small-right"
                                                   type="checkbox"
                                                   v-model="selectedFilterValues[filter.option.code].codes"
                                                   :value="filterValue.code"
                                                   :name="filter.option.code"
                                                   :id="filter.option.code + '_' + filterValue.code"
                                                   @change="onFilterChanged">
                                            <label :for="filter.option.code + '_' + filterValue.code">{{ filterValue.name }}</label>
                                        </li>
                                    </ul>
                                </div>

                                <!-- number -->
                                <div v-if="filter.option.type == 'NumberInt' || filter.option.type == 'NumberDecimal'"
                                     uk-dropdown="mode: click; boundary: ! .uk-button-group .uk-button; boundary-align: true;">
                                    <div class="uk-inline" style="width:100px;">
                                        <input class="uk-input" type="number"
                                               :name="filter.option.code + '_min'"
                                               v-model="selectedFilterValues[filter.option.code].minValue"
                                               :placeholder="filter.option.facets[0].aggregationValues.Min"
                                               @input="onInputFilter">
                                    </div>
                                    -
                                    <div class="uk-inline" style="width:100px;">
                                        <input class="uk-input" type="number"
                                               :name="filter.option.code + '_max'"
                                               v-model="selectedFilterValues[filter.option.code].maxValue"
                                               :placeholder="filter.option.facets[0].aggregationValues.Max"
                                               @input="onInputFilter">
                                    </div>
                                </div>

                                <div v-if="filter.option.type == 'Text' || filter.option.type == 'TextArea' || filter.option.type == 'TextHtml' || filter.option.type == 'TextMarkdown'"
                                     uk-dropdown="mode: click; boundary: ! .uk-button-group .uk-button; boundary-align: true;">
                                    <div class="uk-inline" style="width:200px;">
                                        <input class="uk-input" type="text" placeholder="..."
                                               :name="filter.option.code"
                                               v-model="selectedFilterValues[filter.option.code].text"
                                               @input="onInputFilter">
                                    </div>
                                </div>
                            </div>

                        </div>
                    </li>
                </ul>

                <div class="activefiltersbox uk-position-relative uk-padding uk-padding-remove-top uk-padding-remove-bottom uk-flex">
                    <div v-if="productsData" class="results uk-text-small uk-display-inline-block">
                        <span v-html="resources['ResultsNumber'].format('<b>' + total + '</b>')"></span>
                    </div>

                    <!-- filtri selezionati -->
                    <div class="activefilters uk-flex uk-flex-top">
                        <div v-for="selValue in selectedFiltersNamesAndValueLabels" class="gray uk-margin-small-right">
                            <span v-if="selValue.value && selValue.value != ''">{{ selValue.name }} = {{ selValue.value }}</span>
                            <span v-else>{{ selValue.name }}</span>
                            <a @click="onRemoveFilter(selValue.optionCode)" class="dark uk-margin-small-left" uk-icon="icon: close; ratio: .7"></a>
                        </div>
                    </div>

                    <a href="" class="activefiltersdelete uk-text-uppercase uk-text-bold blue uk-text-small uk-flex uk-flex-middle"
                       style="font-size: .65rem;"
                       @click="onResetFilters"
                       v-if="selectedFiltersNamesAndValueLabels.length > 0">
                        <img class="dark" width="25" height="25" :alt="resources['RemoveAllFilters']" uk-img="data-src:/icone/ico_cestino.svg" uk-svg>
                        {{ resources['RemoveFilters'] }}
                    </a>
                </div>
            </div>
        </form>


        <div v-if="!searchIsLoading" class="uk-width-expand@m uk-margin-small-bottom">
            <img class="product-available-icon" width="20" height="" alt="" uk-img="data-src:/icone/ico_prodotti_stock.svg" uk-svg />
            <small class="uk-text-italic">= <span class="uk-text-bold">{{ resources["StockProducts"] }}</span>&nbsp;&nbsp; {{ resources["StockProductsCaption"] }}</small>
        </div>

        <localization-provider :language="languageId + 's'">
            <intl-provider :locale="languageId + 's'">
                <grid v-if="productsData && listColumns"
                      :columns="listColumns"
                      :data-items="productsData"
                      :group="group"
                      :sort="sort"
                      :pageable="true"
                      :sortable="sortable"
                      :skip="skip"
                      :take="take"
                      :total="total"
                      @pagechange="onPageChanged"
                      @sortchange="onSortChanged">
                    <template v-slot:localizationTemplate="{ props }">
                        <td colspan="1">
                            {{ localizeCellValue(props.dataItem[props.field]) }}
                        </td>
                    </template>
                    <template v-slot:designationTemplate="{ props }">

                        <!--questo td non deve prendere la classe position: sticky;-->
                        <td v-if="renderCell(props)" colspan="1" class="designation-cell tooltip-cell">
                            <a @click="onProductClick(props.dataItem)" :href="props.dataItem.url">
                                {{ props.dataItem.name }}

                                <img v-if="props.dataItem.isAvailable" class="product-available-icon" width="20" height="" alt="" uk-img="data-src:/icone/ico_prodotti_stock.svg" uk-svg />
                            </a>

                            <div v-if="!isTouchDevice" class="products-list-tooltip" uk-drop="pos: right-top">
                                <a @click="onProductClick(props.dataItem)" :href="props.dataItem.url" class="bgwhite uk-flex uk-flex-middle">
                                    <div class="tootlip-img uk-align-left uk-margin-small-right uk-margin-remove-bottom">
                                        <img v-if="props.dataItem.mainMediaPath" :data-src="'/images/160/120/' + props.dataItem.mainMediaPath"
                                             :alt="`${props.dataItem.name} ${resources[props.dataItem.familyCode]}`" uk-img /> <!--100/83-->
                                    </div>
                                    <div style="zoom: .8;">
                                        <div>
                                            <span class="blue uk-text-normal uk-text-small uk-text-bold uk-text-uppercase">{{ resources[props.dataItem.familyCode] }}</span>
                                            <br />
                                            <strong class="blue uk-text-large" title="Designation">{{ props.dataItem.name }}</strong>
                                            <br />
                                            <div class="gray uk-text-small">
                                                <div>
                                                    <span style="white-space: nowrap;">{{ getProductAttributeName('d_in_mm') }}= {{ props.dataItem['d_in_mm'] }}&nbsp;&nbsp;&nbsp;</span>
                                                    <span style="white-space: nowrap;">{{ getProductAttributeName('d_out_mm') }}= {{ props.dataItem['d_out_mm'] }}&nbsp;&nbsp;&nbsp;</span>
                                                    <span style="white-space: nowrap;">{{ getProductAttributeName('b_mm') }}= {{ props.dataItem['b_mm'] }}&nbsp;&nbsp;&nbsp;</span>
                                                </div>
                                                <div>
                                                    <span v-if="props.dataItem['cr_dyn_kn']"
                                                          style="white-space: nowrap;">{{ getProductAttributeName('cr_dyn_kn') }}= {{ props.dataItem['cr_dyn_kn'] }}&nbsp;&nbsp;&nbsp;</span>
                                                    <span v-if="props.dataItem['c0r_sta_kN']"
                                                          style="white-space: nowrap;">{{ getProductAttributeName('c0r_sta_kN') }}= {{ props.dataItem['c0r_sta_kN'] }}&nbsp;&nbsp;&nbsp;</span>
                                                </div>
                                            </div>
                                            <strong v-if="props.dataItem.isAvailable" class="uk-display-block uk-float-right uk-margin-small-top gray"><span class="uk-text-large">{{ props.dataItem.netPrice.toCurrencyString(languageId) }}</span> {{ resources['VatExcluded'] }}</strong>
                                            <div class="uk-clearfix" />
                                        </div>
                                    </div>
                                </a>
                            </div>

                        </td>
                    </template>
                </grid>
            </intl-provider>
        </localization-provider>
    </div>
</template>

<style scoped>
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }

    .product-tooltip {
        z-index: 999;
        background-color: white;
    }
</style>

<script lang="ts" src="./ProductsList.vue.ts"></script>
